// extracted by css-extract-rspack-plugin
export default {"card":"card-YX8QWA"};